import { Box, Typography } from "@mui/material";
import React from "react";
import styles from "./services.module.scss";

const RetirementPlanning = () => {
  return (
    <Box>
      <Typography className={styles.details}>
        <b>This is for information purpose only. </b>You must consult your own
        Financial Manager. It is derived from such as Money Management Magazine/
        Fidelity investments etc.
      </Typography>
      <Typography className={styles.details}>
        <ol style={{margin:0}}>
          <li >
            First do not plan your place of Retirement depending on Children. If
            they happen to be near your place it is a plus.
          </li>
          <li>
            Plan preferably 2 years ahead Move to Gated Community for Seniors.
            HOA. No headaches of Maintenance and easy to get needed help and
            keep Company. The place shall be Rock soild.
          </li>
        </ol>
      </Typography>
      <Typography className={styles.details}>
        <b>The place shall be Rock Solid future closer to needed Amenities.</b>
      </Typography>
      <Typography className={styles.details}>
        <ol style={{margin:0}}>
          <li>
            Financial Management: By Ways of, Such as Fedelity/ Chase/
            Meryl-Lynch / or other / or on Your OWN. Most of us need expert help
            and advice to start first.
          </li>
          <li>
            No No for free Lunch Advisers. Find one Broker with Track record and
            search his background for 10 yrs. or more. Pay no more than 1.5%
            commission. Check on Brokerscheckinfra.org for reference
          </li>
          <li>
            Consolidate IRA to one Investment Account. Example Fidelity, Morgan
            Chase, Etc.
          </li>
          <li>
            Have Trusted ?? Relative to over see hopefully you have one? Less
            commission.
          </li>
          <li>
            IRA Tax withdrawal leave to Accountant. Pension Plan/ IRA it is
            mandatory with Minimal withdrawal.
          </li>
          <li>
            Tax Free Municipal Bonds Investment rated/ Annuities /CD's be part
            of your Portfolio. Stocks percentage(25 t0 40%) depending on your
            Risk tolerance and deiversfied
          </li>
          <li>
            Income: Steady income portfolio plus SSI income enough to cover your
            comfortable living and Travel.
          </li>
          <li>
            Expenses: Besides your Daily Living You need EXTRA 4% of Home Value
            to maintain your home paid off mortgage.
          </li>
          <li>
            Consider Health Care Cost '&gt;' 65 yrs. Besides your Insurance and
            Medicare Out of Pocket $7,500. For &gt; 75 need additional?
          </li>
          <li>
            It is advised at 70 years. of age Plan for 25-year Withdrawal Plan.
            (average Life Span)
          </li>
          <li>Aim at Four percent 4% return is safe to last that long.</li>
          <li>Flex your withdrawal to mitigate any losses in portfolio.</li>
          <li>
            If you want to live 30 yrs. from 70 You need Extra 300,000.plus
            inflation for Health Care.
          </li>
          <Typography className={styles.details}>
            <b>Stay healthy by Healthy Habits:</b>
            <ul style={{margin:0}}>
              <li>Daily walking for 30 min.</li>
              <li>Keep weight no more than 30. Lbs to your ideal weight.</li>
              <li>Eat more vegetarian less of Non-veg. (Non-Veg-30%) 25% less chance of dying early.</li>
            </ul>
          </Typography>
        </ol>
      </Typography>
      <Typography className={styles.details}>
        <b>Disclaimer: </b>This is for information purpose only. It is derived
        from such as Money Management Magazine/ Fidelity investments etc. The
        information to be used as of help and support only and no other purpose.
        You must consult your own financial manager, attorney, Accountant or
        other Experts in the field.
      </Typography>
    </Box>
  );
};

export default RetirementPlanning;
